import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const NomineeDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td className="text-right pr-5">
                                    {data?.nominees[0]?.nominee_title ? data?.nominees[0]?.nominee_title : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>First Name</th>
                                <td className="text-right pr-5">
                                    {data?.nominees[0]?.nominee_firstName ? data?.nominees[0]?.nominee_firstName : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Middle Name</th>
                                <td className="text-right pr-5">
                                    {data?.nominees[0]?.nominee_middleName ? data?.nominees[0]?.nominee_middleName : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Last Name</th>
                                <td className="text-right pr-5">
                                    {data?.nominees[0]?.nominee_lastName ? data?.nominees[0]?.nominee_lastName : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Relation</th>
                                <td className="text-right pr-5">
                                    {data?.nominees[0]?.nominee_relation ? data?.nominees[0]?.nominee_relation : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>DOB</th>
                                <td className="text-right pr-5">
                                    {data?.nominees[0]?.nominee_dob ? formattedDateOnly(data?.nominees[0]?.nominee_dob) : '-'}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default NomineeDetails;